import { ReactNode } from 'react';
import { Radio, RadioChangeEvent } from 'antd';
import { PreviewRadioGroup, Text } from '../Ant';
import LabelledRadioGroup from '../labelledRadioGroup/labelledRadioGroup';

export interface IPreviewOption<T extends string> {
  value: T;
  label: string;
  preview: ReactNode;
  testId: string;
}

interface IPreviewOptionGroupProps<T extends string> {
  title: string;
  options: IPreviewOption<T>[];
  value: T;
  onChange: (value: T) => void;
  testId: string;
}

const PreviewOptionGroup = <T extends string>({
  title,
  options,
  value,
  onChange,
  testId,
}: IPreviewOptionGroupProps<T>) => (
  <LabelledRadioGroup title={title} testId={testId}>
    <PreviewRadioGroup
      value={value}
      onChange={(event: RadioChangeEvent) => onChange(event.target.value as T)}
    >
      {options.map((option) => (
        <Radio key={option.value} value={option.value}>
          <span className="option-preview" aria-hidden="true">
            {option.preview}
          </span>
          <Text
            $fontsize="12px"
            $weight={500}
            $lineheight="16px"
            $color="title"
            className="ta-center"
            data-testid={option.testId}
          >
            {option.label}
          </Text>
        </Radio>
      ))}
    </PreviewRadioGroup>
  </LabelledRadioGroup>
);

export default PreviewOptionGroup;
